'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _baseBcReactComponent = require('@bibliocommons/base-bc-react-component');

var _baseBcReactComponent2 = _interopRequireDefault(_baseBcReactComponent);

var _pinchHandler = require('../../pinch-handler');

var _pinchHandler2 = _interopRequireDefault(_pinchHandler);

require('../styles/PanZoom.scss');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var PanZoom = function (_BcReactComponent) {
  _inherits(PanZoom, _BcReactComponent);

  function PanZoom(props) {
    _classCallCheck(this, PanZoom);

    var _this = _possibleConstructorReturn(this, (PanZoom.__proto__ || Object.getPrototypeOf(PanZoom)).call(this, props));

    _this.bindAll('handleUpdate');
    return _this;
  }

  _createClass(PanZoom, [{
    key: 'handleUpdate',
    value: function handleUpdate(obj) {
      this.props.handleUpdate(obj);
    }
  }, {
    key: 'getContentStyles',
    value: function getContentStyles() {
      var _props = this.props,
          scale = _props.scale,
          x = _props.x,
          y = _props.y;

      return {
        transform: 'scale(' + scale + ') translateY(' + y + 'px) translateX(' + x + 'px)'
      };
    }
  }, {
    key: 'getContainerStyles',
    value: function getContainerStyles() {
      var _props2 = this.props,
          backgroundColor = _props2.backgroundColor,
          height = _props2.height,
          width = _props2.width;

      var ratio = height / width * 100;
      return {
        paddingTop: ratio.toFixed(2) + '%',
        backgroundColor: backgroundColor
      };
    }
  }, {
    key: 'render',
    value: function render() {
      var _props3 = this.props,
          children = _props3.children,
          className = _props3.className,
          props = _objectWithoutProperties(_props3, ['children', 'className']);

      return _react2.default.createElement(
        _pinchHandler2.default,
        _extends({}, props, { onUpdate: this.handleUpdate }),
        _react2.default.createElement(
          'div',
          { className: (0, _classnames2.default)('cp-pan-zoom', className), tabIndex: '0' },
          _react2.default.createElement(
            'div',
            { className: 'pan-zoom-container', style: this.getContainerStyles() },
            _react2.default.createElement(
              'div',
              { className: 'pan-zoom-inner' },
              _react2.default.createElement(
                'div',
                { className: 'pan-zoom-content', style: this.getContentStyles() },
                children
              )
            )
          )
        )
      );
    }
  }]);

  return PanZoom;
}(_baseBcReactComponent2.default);

exports.default = PanZoom;


PanZoom.propTypes = {
  backgroundColor: _react.PropTypes.string,
  handleUpdate: _react.PropTypes.func.isRequired,
  onPinchStart: _react.PropTypes.func,
  onPinchStop: _react.PropTypes.func,
  initialScale: _react.PropTypes.number,
  scale: _react.PropTypes.number.isRequired,
  height: _react.PropTypes.number.isRequired,
  width: _react.PropTypes.number.isRequired,
  x: _react.PropTypes.number.isRequired,
  y: _react.PropTypes.number.isRequired
};

PanZoom.defaultProps = {
  backgroundColor: '#fff'
};


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/base-pan-zoom/lib/components/pan-zoom/components/PanZoom.component.js
// module id = 1335
// module chunks = 1